/**
 * Порядок «что команда роняет чаще» (#846): один на карточку Quality и на
 * взгляд «Команда» экрана «Возражения», чтобы карточка и экран, на который она
 * ведёт, называли первым один и тот же код.
 *
 * Сначала больше разговоров с неотработанным возражением, затем выше доля
 * неотработанных, затем больше разговоров; при полном равенстве — код по
 * кодовым единицам (не по локали: порядок не должен зависеть от языка
 * интерфейса).
 */
export interface UnhandledRankable {
  code: string;
  calls: number;
  unhandledCalls: number;
}

export function compareByUnhandled(a: UnhandledRankable, b: UnhandledRankable): number {
  return (
    b.unhandledCalls - a.unhandledCalls ||
    b.unhandledCalls / b.calls - a.unhandledCalls / a.calls ||
    b.calls - a.calls ||
    (a.code < b.code ? -1 : a.code > b.code ? 1 : 0)
  );
}
